<template>
  <el-dialog
    title="Lista de Objetos"
    center
    :fullscreen="true"
    v-loading="loading"
    :close-on-click-modal="false"
    :visible.sync="dialog"
  >
    <el-row type="flex" justify="end">
      <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
        <el-pagination
          class="right"
          :page-size="filter.records"
          background
          @current-change="fetchRecords"
          @size-change="changeSize"
          :current-page.sync="filter.page"
          layout="sizes, prev, pager, next"
          :page-sizes="[
            50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
          ]"
          :total="total"
        ></el-pagination>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
        <el-input
          :placeholder="$t('pesquisar')"
          prefix-icon="el-icon-search"
          v-model="filter.word"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="fetchRecords"
          ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      stripe
      size="mini"
      style="width: 100%"
      :default-sort="{ prop: 'name', order: 'ascending' }"
    >
      <el-table-column
        sortable
        prop="tag"
        :label="$t('etiqueta')"
      ></el-table-column>
      <el-table-column
        sortable
        prop="serviceName"
        :label="$t('servico')"
      >
      <template slot-scope="scope">
        {{ scope.row.serviceName }} ({{ scope.row.serviceCode }})
      </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="sourcezipcode"
        :label="$t('cep-origem')"
      ></el-table-column>
      <el-table-column
        sortable
        prop="destinyzipcode"
        :label="$t('cep-destino')"
      ></el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialog = false">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
export default {
  name: "AuditFileDetailObject",
  props: ["id"],
  data() {
    return {
      dialog: false,
      loading: false,
      tableData: [],
      total: 0,
      filter: {
        page: 1,
        records: 50,
        word: '',
      }
    };
  },
  methods: {
    open() {
      const vm = this;
      vm.dialog = true;
      vm.fetchRecords()

    },
    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetchRecords();
    },
    fetchRecords() {
      const vm = this;
      if (!vm.id) return false;
      vm.loading = true;
      AuditService.objects(vm.id, vm.filter.word, vm.filter.records, vm.filter.page)
        .then((response) => {
          vm.total = response.total;
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => vm.loading = false);
    }
  },
};
</script>